import { createAction } from 'redux-api-middleware'
export default {
  createAction,
}
